<template>
  <div id="result">
    <video id="v2" autoplay loop muted height="800rem" width="800rem">
      <source
        src="../assets/mp4/ebs.mp4"
        type="video/mp4"
      />
    </video>
    <div class="login-d">
      <div class="video-login">
        <div id="v1"></div>

        <div id="login-item">
          <div id="login-web">
         <h1 id="login-logo"><img src="../assets/img/logo.png" alt="" /></h1>
            <div id="login-text">
           
              <span class="text">数</span>
              <span></span>
              <span>字</span>
              <span></span>
              <span>孪</span>
              <span></span>
              <span>生</span>
              <span></span>
              <span>能</span>
              <span></span>
              <span>源</span>
              <span></span>
              <span>互</span>
              <span></span>
              <span>联</span>
              <span></span>
              <span>网</span>
              <span></span>
              <span>平</span>
              <span></span>
              <span>台</span>
            </div>
          </div>
          <div id="kong"></div>
          <div id="login-user">
            <div id="yes"><img src="../assets/img/success.png" alt="" /></div>
            <p class="mylogin">你的账户：{{ Useremail }}密码重置成功</p>
            <div class="mylogin-arr">
              请妥善保管好你的账号及密码，如有疑难请联系管理员。
            </div>
            <div class="web-btn">
              <router-link to="login"
                ><el-button class="btn-two" size="10"
                  >返回登录({{ timer }})</el-button
                ></router-link
              >
            </div>
          </div>
        </div>
        
      </div>
       <div class="login-mvker">
            <div class="mvker-item">
              <p class="mvker-text">武汉魅客科技有限公司</p>
              <h4 class="mvker-logo">
                <img src="../assets/img/text.png" alt="" />
              </h4>
            </div>
            <div class="copyright">版权 © 2021武汉魅客科技出品</div>
          </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "result",
  data() {
    return {
      Useremail: "",
      timer: "5",
    };
  },
  mounted() {
    this.time();
    this.Useremail = window.localStorage.getItem("Useremail");
  },
  methods: {
    time() {
      var tologin = setInterval(() => {
        this.timer--;
        if (this.timer < 1) {
          clearInterval(tologin);
          this.$router.push("/login");
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="less">
#result {
  width: 100%;
  height: 100%;

}

#login-web {
  .w(290);
  margin: auto;
  margin-top: 22%;

  #login-logo {
    img {
      width: 100%;
      height: 100%;
    }
  }

  #login-text {
    .w(286);
    display: flex;
    justify-content: space-between;
    color: #0d94ff;

    span {
      font-size: 18px;
    }
  }
}
#kong {
  .h(81);
}
#login-user {
 .w(600);
 height:52.80vh;
  box-shadow: 0rem 0rem 40rem 0rem rgba(0, 43, 102, 0.16);
  border-radius: 12rem;
  padding-top: 65rem;
  // margin-bottom: 88rem;
  background-color: #ffffff;
  #yes {
    .w(100);
    .h(100);
    background-color: black;
    margin: auto;
    border-radius: 50%;
    background-color: #fff;
    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
    }
  }
  .mylogin {
    text-align: center;
    font-size: 18rem;
    color: #333333;
    margin-top: 47rem;
  }
  .mylogin-arr {
    margin-top: 30rem;
    font-size: 14rem;
    color: #cccccc;
    text-align: center;
    margin-bottom: 91rem;
  }

  .el-button .el-button--primary {
   width: 141px;
    background: #0d94ff;
    border-radius: 4px;
    text-align: center;
 
  }
  .btn-two {
    width: 141px;  
     line-height: 5rem;
    border: 1rem solid rgba(167, 161, 161, 0.873) !important;
    background-color: rgba(255, 250, 250, 0.22) !important;
    color: #333333;
    border-radius: 4px;
    // margin-left: 20rem;
    font-size: 14rem;
  }
}
.web-btn {
  width: 400rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 0rem 0 100rem 0;
}
    .login-mvker {
            line-height: 40px;
            margin-top: 2%;

            .mvker-item {
                width: 300px;
                margin: auto;
                display: flex;
                justify-content: space-around;

                .mvker-text {
                    white-space: nowrap;
                    font-size: 16px;
                    text-align: center;
                    color: #999999;
                    // margin-bottom: 3%;
                }

                .mvker-logo {
                   width: 75px;
                   height: 15px;
                    text-align: right;

                    img {
                      width: 75px;
                   height: 15px;
                    }
                }
            }

            .copyright {
                // .w(230);
                margin: auto;
                font-size: 16px;
                text-align: center;
                color: #999999;
            }
        }
video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
video:focus {
  outline: none;
}
#v1 {
  // padding: 50rem;
  margin-top: 8%;

  .w(800);
  .h(800);
  z-index: 0;
}
#v2 {
  // padding: 50rem;
  margin-top: 6%;
  position: absolute;
  .w(800);
  .h(800);
  z-index: 0;
  left: 10%;
}
.video-login {
  display: flex;
  justify-content: space-between;
  z-index: 1;
  // padding-left: 200rem;
}

.login-d {
  width: 100%;
  height: 100%;
  background: url(../assets/img/loginBJ1.png);
  //  background-color: #ffffff;
  background-size: 100% 100%;
  position: fixed;
  z-index: 9;
  padding: 0 14% 0 10%;
}
</style>